import { render, staticRenderFns } from "./mgmtCPT.vue?vue&type=template&id=1be3ba34&scoped=true&"
import script from "./mgmtCPT.vue?vue&type=script&lang=js&"
export * from "./mgmtCPT.vue?vue&type=script&lang=js&"
import style0 from "./mgmtCPT.vue?vue&type=style&index=0&id=1be3ba34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3ba34",
  null
  
)

export default component.exports